import { Component, OnInit, Injector, Input } from '@angular/core';

import { FsCreateUpdateFilesComponent } from '../fs-create-update-files/fs-create-update-files.component';
import { FsCreateItemComponent } from '../fs-create-item/fs-create-item.component';
import { IBitfCloseEvent } from '@interfaces';
import { FsStore } from '@models';

@Component({
  selector: 'prada-fs-create-files-button',
  templateUrl: './fs-create-files-button.component.html',
  styleUrls: ['./fs-create-files-button.component.scss'],
})
export class FsCreateFilesButtonComponent extends FsCreateItemComponent implements OnInit {
  @Input() fsStore: FsStore;
  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  addFiles() {
    const ref = this.dialogService.dialog.open(FsCreateUpdateFilesComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: 'auto',
      maxHeight: '700px',
      disableClose: true,
      data: { fsStore: this.fsStore },
    });
    ref.afterClosed().subscribe((result: IBitfCloseEvent<any>) => {
      if (result && result.data && result.data.length > 0) {
        this.apiCallStateService.setStore(() => {
          this.setCreatedSortDesc();
        }, this.apiCallStateName);
      }
    });
  }
}
